import { Controller } from 'libraries/front-end-core/core/Router'
import { startsWith, trimStart } from 'libraries/lodash'
import Main from './Main'
import { expand } from 'libraries/front-end-core/services/ShortenerService'
import { replaceUrl } from 'libraries/front-end-core/core/history'
import { isValidResponse } from 'libraries/front-end-core/helpers/dataflow'
import { SHARE } from 'constants/controllers'
import { takeUntil } from 'rxjs'

export default new Controller({
  name: SHARE,
  route: '(:aol/)share/:short',
  controller (Router, evt, render) {
    const { url: pageId, params: { short } } = evt
    expand(short).pipe(
      takeUntil(Router)
    ).subscribe(response => {
      if (isValidResponse(response)) {
        const url = startsWith(response, '/') ? trimStart(response, '/') : response
        const urlWithShort = `${url}?short=${short}`
        replaceUrl(urlWithShort)
      } else {
        render({ Main }, { response }, { pageId })
      }
    })

    return pageId
  }
})
